import React, { useState, useEffect } from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { getuser } from '../helpers/user.helper';
import formatMoney from '../helpers/money.helper';
import formatDate from '../helpers/date.helper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from "react-router-dom";
import { ListByCustomer, CheckSincronizedSeller } from '../services/seller.service';
import { useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Footer from '../components/Footer';


export default function ClienteVendasList(props) {
    let navigate = useNavigate();
    const [vendasArray, setVendas] = useState(undefined);

    let { id } = useParams();
    let { customer } = props.navigate.location?.state;

    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }

        async function fetchData() {
            let vendas = await ListByCustomer(id);
            setVendas(vendas?.data);
        }

        fetchData();
    }, [])

    let state = [];

    const showItemClick = (rowData) => {
        navigate(`/venda/${rowData.id}`, { venda: rowData })
    }

    const checkItem = async (rowData) => {
        Swal.fire({
            title: '<strong>Mudar status de venda?</strong>',
            icon: 'question',
            html: 'Deseja marcar venda como lançada no sistema? ',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
            cancelButtonText: 'Não',
        }).then(async (result) => {
            if (result.value) {
                let result = await CheckSincronizedSeller(rowData.id);
                if (result.status === 200) {
                    let vendas = await ListByCustomer(id);
                    setVendas(vendas?.data);
                }
            }
        });

    }

    const formatIntegrateStatus = (rowData) => {
        if (rowData) {
            return "Sim";
        }
        else {
            return "Não";
        }
    }


    const optionButtons = (rowData, column) => {
        return (
            <div>
                <button onClick={() => showItemClick(rowData)} title="Visualizar item" type="button" className="btn btn-icon btn-danger btn-sm"><i className="fa fa-search"></i></button>
                {
                    getuser().type == "A" &&
                    <button onClick={() => checkItem(rowData)} title="Marcar como lançado no sistema" type="button" className="btn btn-icon btn-info btn-sm"><i className="fa fa-check"></i></button>
                }

            </div>
        )
    }

    let renderLoad = () => {
        return (
            <div className="table-footer text-center">
                <Loader
                    type="ThreeDots"
                    color="#343A40"
                    height={100}
                    width={100}
                    visible={true}
                />
            </div>
        );
    }

    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />

                </nav>
                <AsideLeft option="vendas" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Vendas Cliente {customer.nome} </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Left col */}
                                <section className="col-lg-12 connectedSortable">
                                    {/* Custom tabs (Charts with tabs)*/}
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-tools">
                                                <ul className="nav nav-pills ml-auto">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" href="/venda/nova" data-toggle="tab">Nova</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {
                                                !vendasArray ?
                                                    renderLoad()
                                                    :
                                                    <div className="tab-content p-0">
                                                        <DataTable value={vendasArray} style={{ marginBottom: 50 }} responsive className="p-datatable-customers"
                                                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                                            emptyMessage="Você Ainda não realizou vendas"
                                                        >
                                                            <Column field="id" header="Código" />
                                                            <Column field={(row) => formatDate(row.dataImportacao)} header="Data" filter={true} />
                                                            <Column field={(row) => row.usuario && row.usuario.nome} header="Usuário" filter={true} />
                                                            <Column field="cliente" header="Cliente" filter={true} />
                                                            <Column field={(row) => formatMoney(row.total)} header="Valor" />
                                                            <Column field={(row) => formatIntegrateStatus(row.integrate)} header="Lançado no Sistema" filter={true} />

                                                            <Column key="123" body={optionButtons} bodyStyle={{ textAlign: 'center', overflow: 'hidden' }} />
                                                        </DataTable>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    )
}
